import { LoginButton } from './components/LoginButton'
import { LoginDialog } from './components/LoginDialog'
import { PinDialog } from './components/PinDialog'
import { LastestPin } from './components/LastestPin'
import { ImageSelector } from './components/ImageSelector'
import { MapSwitcher } from './components/MapSwitcher'

import getQueryParams from './services/getQueryParams'

import { firebaseConfig, write } from './firebase'
import { user } from './services/auth.service'

const HOST = `${firebaseConfig.databaseURL}/`
const WEB = `https://dead-island-2-eaaaa.web.app`

const icons = {
  Weapons: 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Fshovel.svg?alt=media&token=46ef591e-0033-4ed6-b52b-bf41be674fe1',
  Blueprints: 'https://firebasestorage.googleapis.com/v0/b/dead-island-2-eaaaa.appspot.com/o/assets%2Fblueprint.svg?alt=media&token=d0515df1-35aa-4f49-a734-26c4434ccbaa',
  Collectables: 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Fcollectables.svg?alt=media&token=6bb32342-dd26-4282-bd3c-74931d46b4cb',
  Items: 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Flab.svg?alt=media&token=9050ed16-fd3d-487e-8110-01b6ede15b2a',
  Locations: 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Flocation.svg?alt=media&token=e4305da4-1b8a-4fcc-9445-6557875d4485',
  Animals: 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Fpaws.svg?alt=media&token=5aa0c879-945d-4963-8842-a914dab94a39',
  Resources: 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Facorn.svg?alt=media&token=9a10f502-4029-4758-96f9-923d4e1e7336',
  Creatures: 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Fspider.svg?alt=media&token=e2915abe-36c1-4d55-ae46-59c915c1b3e0',
}
const shareIcon = 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Fshare.svg?alt=media&token=ef3d79ab-2684-4fc4-9592-054cd05c6c0b'

const convertUrlToLink = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank">Link</a>`
  })
}

const getPoint = (item) => {
  const properties = item.properties || {}
  const icon = properties['marker-url'] || item.icon || null
  return {
    type: 'Feature',
    properties: {
      ...properties,
      id: item.id || icon,
      'marker-url': icon,
      offset: properties.offset || [0, 0]
    },
    geometry: {
      type: 'Point',
      coordinates: [item.location.lng, item.location.lat]
    }
  }
}
const featureCollection = (items) => {
  return {
    type: 'FeatureCollection',
    features: items.map(item => getPoint(item))
  }
}

const createPin = (id, lng, lat) => {
  const close = document.body.querySelector('.mapboxgl-popup-close-button')
  close && close.click()
  const pinDialog = document.createElement('pin-dialog')
  if (id) {
    const item = features.find(i => i.id === id)
    pinDialog.setAttribute('id', id)
    pinDialog.setAttribute('category', item.properties.category)
    pinDialog.setAttribute('item', item.properties.item)
    pinDialog.setAttribute('name', item.properties.name)
    pinDialog.setAttribute('lng', item.location.lng)
    pinDialog.setAttribute('lat', item.location.lat)
    pinDialog.setAttribute('size', item.properties.size)
    pinDialog.setAttribute('pin', item.properties['marker-url'])
    pinDialog.setAttribute('description', item.properties.description)
    pinDialog.setAttribute('image', item.properties.image)
    pinDialog.setAttribute('link', item.properties.link)
    pinDialog.setAttribute('mode', 'edit')
  }
  if (lng && lat) {
    pinDialog.setAttribute('lng', lng)
    pinDialog.setAttribute('lat', lat)
  }
  pinDialog.setAttribute('layer', layer)
  pinDialog.setAttribute('images', JSON.stringify(images))
  pinDialog.setAttribute('items', JSON.stringify(
    [...new Set(features.map(i => i.properties.item))]
  ))
  pinDialog.setAttribute('names', JSON.stringify(
    [...new Set(features.map(i => i.properties.name))]
  ))

  document.body.appendChild(pinDialog)
  pinDialog.addEventListener('onclose', ({detail}) => {
    const item = features.find(i => i.id === id)
    const itemFiltered = filtered.find(i => i.id === id)
    item && item.properties && Object.assign(item.properties, detail)
    itemFiltered && itemFiltered.properties && Object.assign(itemFiltered.properties, detail)
    setFeatures()
  })
}
window['deletePin'] = id => {
  if (window.confirm('Are you sure you want to delete?')) {
    const item = features.find(i => i.id === id)

    return fetch(`${HOST}/items/${id}.json`, {
      method: 'PATCH',
      body: JSON.stringify({
        status: 'deleted',
        updated_by: user.value.email,
        updated_at: Date.now(),
        id: item.properties.id,
        category: item.properties.category,
        item: item.properties.item,
        name: item.properties.name,
        lng: item.location.lng,
        lat: item.location.lat,
        size: item.properties.size,
        pin: item.properties.pin,
        description: item.properties.description || '',
        image: item.properties.image || '',
        link: item.properties.link || '',
        user_id: user.value.id,
        layer: item.properties.layer || '',
      })
    })
    .then(() => {
      features.splice(features.findIndex(i => i.id === id), 1)
      reload()
      const close = document.body.querySelector('.mapboxgl-popup-close-button')
      close && close.click()
    })
  }
}
window['createPin'] = createPin

async function copyToClipboard(text) {
  // Use the Clipboard API for modern browsers
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text).then(
      function() {
        console.log('Text successfully copied to clipboard.');
      },
      function(err) {
        console.error('Failed to copy text: ', err);
      }
    );
  } else {
    // Fallback for old browsers (e.g., Internet Explorer)
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successfully' : 'unsuccessfully';
      console.log('Text ' + msg + ' copied to clipboard.');
    } catch (err) {
      console.error('Failed to copy text: ', err);
    } finally {
      document.body.removeChild(textArea);
    }
  }
}

window.copyUrl = (id) => {
  copyToClipboard(`https://mmo-wiki.com/dead-island-2/dead-island-2-interactive-map?id=${id}`)
  .then(() => {
    setTimeout(() => {
      document.querySelector('.tooltip').blur();
    }, 2000)
  })
}

const config = {
  "tile_sets": {
    "min_zoom": 14,
    "max_zoom": 18,
    "extension": "jpg",
  },
  // 14.28/-0.01298/0.01118
  "initial_zoom": 14,
  "start_lat": -0.01298,
  "start_lng": 0.0019,
  "overlay": null,
  "overzoom": false,
  bounds: [-168.75, 83.83, -167.5, 83.98],
  // {
  //   "_sw": {
  //     "lng": -0.02237320088056549,
  //     "lat": -0.039105146800977764
  //   },
  //   "_ne": {
  //     "lng": 0.03857299623550148,
  //     "lat": 0.005355962772512157
  //   }
  // }
}

const mapboxgl = window['mapboxgl']

mapboxgl.accessToken = 'pk.eyJ1IjoibW1vd2lraSIsImEiOiJjbGVrZXg1aG0wYWU1M3Nxc3F6anYzZmY2In0.uNKQgtCPsACL6oiBCDsbWw';
const map = new mapboxgl.Map({
  container: 'map',
  zoom: config.initial_zoom,
  minZoom: config.tile_sets.min_zoom,
  maxZoom: config.tile_sets.max_zoom,
  center: [config.start_lng, config.start_lat],
  style: 'mapbox://styles/mmowiki/clgq64hyv00i901qugqrgf0u3'
});
let features = []
let images = []
let layer = 'layer0'

map.addControl(new mapboxgl.FullscreenControl())
map.addControl(new mapboxgl.NavigationControl());

const loadLayer = () => {
  map.addSource('markers', {
    'type': 'geojson',
    'data': featureCollection([])
  });
   
  map.addLayer({
    'id': 'markers',
    'type': 'symbol',
    'source': 'markers',
    'layout': {
      'icon-image': ['get', 'marker-url'],
      'icon-allow-overlap': true,
      'icon-offset': ['get', 'offset'],
      'icon-size': ['get', 'size']
    }
  });
}

map.on('style.load', () => {
  console.log('style.load', filtered)
  loadLayer();
});

map.on('load', () => {
})

let pidClick
map.on('click', (e) => {
  window.history.replaceState(null, document.title, `?point=${e.lngLat.lng},${e.lngLat.lat}`)
  if (user.value) {
    pidClick = setTimeout(() => {
      new mapboxgl.Popup({offset: [0, -2]})
        .setLngLat([e.lngLat.lng, e.lngLat.lat])
        .setHTML(`
          <div class="popup-content py-20px">
            <h3>
              Lng: ${(e.lngLat.lng).toFixed(6)} 📍<br>Lat: ${(e.lngLat.lat).toFixed(6)} 📍
            </h3>
            <a class="btn-grad" onclick="createPin(null, ${e.lngLat.lng}, ${e.lngLat.lat})">Submit Location</a>
          </div>
        `)
        .addTo(map);
    }, 150)
  }
})

const setPopup = e => {
  clearTimeout(pidClick)
  const feature = e.features[0]
  new mapboxgl.Popup({offset: [0, -20]})
    .setLngLat([e.lngLat.lng, e.lngLat.lat])
    .setHTML(`
      ${feature.properties.image ? `<div class="popup-image-wrapper">
        <img onclick="showLightbox('${feature.properties.image}')" src="${feature.properties.image}"/>
      </div>` : ''}
      <div class="popup-content ${!feature.properties.image && 'py-20px'}">
        <h2>
          ${feature.properties.name}
          <span class="icon tooltip top" tabindex="-1" onclick="copyUrl('${feature.properties.id}')">
            <img src="${shareIcon}"/>
            <span class="tiptext">Copied!</span>
          </span>
          ${user.value && user.value.admin ? `<span class="icon" onclick="createPin('${feature.properties.id}')">✎</span>` : ''}
          ${user.value && user.value.admin ? `<span class="icon trash" onclick="deletePin('${feature.properties.id}')">🗑️</span>` : ''}
        </h2>
        ${feature.properties.description ? `<p class="description">${convertUrlToLink(feature.properties.description)}</p>` : ''}
        <a class="btn-grad" target="_blank" href="${feature.properties.link}">View guide</a>
      </div>
    `)
    .addTo(map);

    // add click event to .description and prevent default
    const nodes = document.querySelectorAll('.popup-content .description')
    const node = nodes[nodes.length - 1]
    node.addEventListener('click', (e) => {
      e.preventDefault()
      if (e.srcElement && e.srcElement.href && e.srcElement.href.includes('?id=')) {
        const [, id] = e.srcElement.href.split('?id=')
        flyTo(id)
      }
    })
}
map.on('click', ['markers'], (e) => {
  setPopup(e)
})
const flyTo = (id) => {
  const feature = features.find(i => i.id === id)
  if (feature) {
    map.flyTo({
      center: [feature.location.lng, feature.location.lat],
      zoom: 17,
      essential: true,
      duration: 1000
    });
    setPopup({
      features: [feature],
      lngLat: {
        lng: feature.location.lng,
        lat: feature.location.lat
      }
    })
  }
}

let filtered = JSON.parse(JSON.stringify(features.filter(i => i.properties.layer === layer)))
const togglers = {}
const setList = () => {
  const categories = [...new Set(filtered.map(i => i.properties['category']))].sort()
  const categoriesList = {}
  const categoriesNumber = {}
  const itemsState = {}
  const categoryState = {}

  categories.map(category => {

    togglers[category] = togglers[category] || 'active'

    categoriesList[category] = [
      ...new Set(filtered
        .filter(i => i.properties.category === category)
        .map(i => i.properties.item)
      )
    ].sort()

    filtered
    .filter(i => i.properties.category === category)
    .map(i => {
      categoriesNumber[i.properties.item] = categoriesNumber[i.properties.item] || 0
      categoriesNumber[i.properties.item] += 1
    })

    const active = filtered.filter(i => i.properties.category === category)
      .find(i => !i.properties.disabled)
    categoryState[category] = active ? 'show' : 'hideAll'
  })

  filtered.map(i => {
    itemsState[i.properties.item] = !i.properties.disabled
  })

  const html = categories.map(category => {
    return `
      <li>
        <b class="category ${categoryState[category]} ${togglers[category]}" name="${category}">
          <img class="category-label" src="${icons[category]}"/>
          <span class="category-label">${category}</span>
        </b>
        <ul>
          ${categoriesList[category].map(item => `
            <li item="${item}" class="item ${itemsState[item] ? 'active' : 'disabled'}">
              ${item} (${categoriesNumber[item]})
            </li>
          `).join('\n')}
        </ul>
      </li>
    `
  })

  document.getElementById('list').innerHTML = html.join('\n')
}

const setLastestPin = features => {
  const [last] = features.slice(-1)
  if (!last) return null
  const lastestPin = document.querySelector('lastest-pin')
  lastestPin.setAttribute('name', last.properties.name)
  lastestPin.setAttribute('image', last.properties.image)
  lastestPin.addEventListener('onClickWrapper', () => {
    if (layer !== last.properties.layer) {
      switchToLayer(last.properties.layer)
    }
    map.flyTo({
      center: [last.location.lng, last.location.lat],
      zoom: 17,
      essential: true,
      duration: 1000
    });
  })
}

const setFeatures = () => {
  const source = map.getSource('markers')
  source && source.setData(featureCollection(filtered.filter(i => !i.properties.disabled)))
}

const reload = () => {
  filtered = JSON.parse(JSON.stringify(features.filter(i => i.properties.layer === layer)))
  setList()
  setLastestPin(features)
  setFeatures()
}

let pid
window.onSearch = el => {
  clearTimeout(pid)
  let term = (el.value || '').toLowerCase()
  pid = setTimeout(() => {
    filtered = JSON.parse(JSON.stringify(features.filter(i => i.properties.layer === layer))).filter(i =>
      i.properties.item.toLowerCase().includes(term) ||
      i.properties.category.toLowerCase().includes(term)
    )
    setFeatures()
    setList()
  }, 300)
}

fetch(`${HOST}/pins/data.json`)
.then(res => res.text())
.then(raw => {
  features = raw.replace(/\"/, '').split('₤').filter(Boolean).map(row => {
    const [category, item, name, lng, lat, size, pin, description, image, linkk, id, _, layer] = row.split(';')
    if (!(item && category && name && lng && lat)) return null

    const link = linkk || `https://mmo-wiki.com/dead-island-2/${name}`
    return {
      id: id || `${category}_${item}_${lng}_${lat}`,
      location: { lng, lat },
      properties: {
        "marker-url": pin || `/assets/pins/${name.toLowerCase()}.png`,
        offset: [0, -50],
        item,
        category,
        name,
        description,
        image,
        link,
        disabled: false,
        size: Number(size || 0.4),
        layer: (layer || 'layer0').replace(/\"/g, '')
      }
    }
  }).filter(Boolean)

  const pins = {}
  ;[...features].reverse().map(i => {
    if (!pins[i.properties.name]) {
      pins[i.properties.name] = {
        img: i.properties['marker-url'],
        key: `${i.properties.category}-${i.properties.item}-${i.properties.name}`,
      }
    } else {
      i.properties['marker-url'] = pins[i.properties.name].img
    }
  })
  images = Object.values(pins)
  .sort((a, b) => {
    return a.key < b.key ? -1 : 1
  })

  filtered = JSON.parse(JSON.stringify(features.filter(i => i.properties.layer === layer)))
  const queryParams = getQueryParams(window.location.href)
  console.log({queryParams})
  if (queryParams.id) {
    features.map(i => {
      if (i.id === queryParams.id) {
        setTimeout(() => {
          // get map-switcher
          layer = i.properties.layer
          const mapSwitcher = document.querySelector('map-switcher')
          mapSwitcher.triggerLayerChange(layer)
          mapSwitcher.hideMainLayer(layer)
          // mapSwitcher.onswitch({detail: layer})
          // switchToLayer(layer)
          setTimeout(() => map.flyTo({
            center: [i.location.lng, i.location.lat],
            zoom: 17,
            essential: true,
            duration: 1000
          }), 500)
        }, 400)
        setTimeout(() => document.querySelector('.main-map-container').style.display = 'none', 500)
      }
    })
  }

  const promises = []
  ;[...new Set([...images.map(i => i.img)])].map(img => {
    return map.loadImage(img, (_, image) => {
      image && promises.push(map.addImage(img, image))
    })
  })
  setList()
  setFeatures()
  Promise.all(promises).then(() => {
    setTimeout(() => setFeatures(), 100)
  })
  setLastestPin(filtered)
})

document.getElementById('list').addEventListener('click', (ev) => {
  if (ev.srcElement.classList.contains('category-label')) {
    const el = ev.srcElement.parentNode
    const disabled = !el.classList.contains('hideAll')
    const name = el.getAttribute('name')
    const found = filtered.filter(i => i.properties.category === name)
    found.map(f => {
      f.properties.disabled = disabled
    })
    setList()
    setFeatures()
  } else if (ev.srcElement.classList.contains('category')) {
    const category = ev.srcElement.getAttribute('name')
    ev.srcElement.classList.toggle('active')
    ev.srcElement.classList.toggle('disabled')
    togglers[category] = togglers[category] !== 'disabled' ? 'disabled' : 'active'
  } else if (ev.srcElement.classList.contains('toggler')) {
    const category = ev.srcElement.getAttribute('name')
    ev.srcElement.classList.toggle('active')
    ev.srcElement.classList.toggle('disabled')
    togglers[category] = togglers[category] !== 'disabled' ? 'disabled' : 'active'
  } else if (ev.srcElement.classList.contains('item')) {
    ev.srcElement.classList.toggle('disabled')
    ev.srcElement.classList.toggle('active')
    const term = ev.srcElement.innerHTML.split('(')[0].trim()
    const disabled = ev.srcElement.classList.contains('disabled')
    const found = filtered.filter(i => i.properties.item === term)
    found.map(f => {
      f.properties.disabled = disabled
    })
    setList()
    setFeatures()
  }
})

window.showAll = () => {
  const elements = document.getElementById('list').getElementsByClassName('hideAll')
  ;[...elements].forEach((element) => {
    element.classList.toggle('hideAll')
  })
  filtered.map(f => f.properties.disabled = false)
  setList()
  setFeatures()
}
window.hideAll = () => {
  const elements = document.getElementById('list').getElementsByClassName('category')
  ;[...elements].forEach((element) => {
    element.classList.add('hideAll')
  })
  filtered.map(f => f.properties.disabled = true)
  setList()
  setFeatures()
}
window.showLightbox = image => {
  const myGallery = GLightbox({
    elements: [
      {
        'href': image,
        'type': 'image',
      }
    ]
  });
  myGallery.open();
}

const mapSwitcher = document.body.querySelector('map-switcher')
const layers = {
  layer0: 'mapbox://styles/mmowiki/clgq64hyv00i901qugqrgf0u3',
  layer1: 'mapbox://styles/mmowiki/clgq661tt00i201pe699e5cug',
  layer2: 'mapbox://styles/mmowiki/clgq6jg3g00jz01qx91es406k',
  layer3: 'mapbox://styles/mmowiki/clgq6kee300jg01r719wr3i07',
  layer4: 'mapbox://styles/mmowiki/clgq6kv6i00k001qx2fde12h2',
  layer5: 'mapbox://styles/mmowiki/clgq6lelo00ib01qz0atl592m',
  layer6: 'mapbox://styles/mmowiki/clgq6lw6n00ka01mj5gc02221',
  layer7: 'mapbox://styles/mmowiki/clgq6mbxp00hz01qqart32z6w',
  layer8: 'mapbox://styles/mmowiki/clgq6oy8m00iq01qyesg8dqws',
  layer9: 'mapbox://styles/mmowiki/clgq6pe1q00i401pehn6ucljr',
}
const switchToLayer = layer => {
  try { map.removeLayer('markers') } catch(_) {}
  
  try { map.removeSource('markers') } catch(_) {}
  map.setStyle(layers[layer]);
  filtered = JSON.parse(JSON.stringify(features.filter(i => i.properties.layer === layer)))
  setList()
  setLastestPin(filtered)

  console.log({filtered, layer})
  setFeatures()

  setTimeout(() => {
    setFeatures()
    const pins = {}
    ;[...features].reverse().map(i => {
      if (!pins[i.properties.name]) {
        pins[i.properties.name] = {
          img: i.properties['marker-url'],
          key: `${i.properties.category}-${i.properties.item}-${i.properties.name}`,
        }
      } else {
        i.properties['marker-url'] = pins[i.properties.name].img
      }
    })
    images = Object.values(pins)
    .sort((a, b) => {
      return a.key < b.key ? -1 : 1
    })
    const promises = []
    ;[...new Set([...images.map(i => i.img)])].map(img => {
      return map.loadImage(img, (_, image) => {
        image && promises.push(map.addImage(img, image))
      })
    })
  }, 300)
}
if (mapSwitcher) {
  mapSwitcher.addEventListener('onswitch', ev => {
    layer = ev.detail
    switchToLayer(layer)
  })
}